import React from 'react';
import { MetricNumbersWrapper, MetricTotal, MetricUnit } from './styled';

const MetricNumbers = ({ metricValue, textColor = '' }) => {
  let textStyle = {};
  if (textColor) {
    textStyle = { color: `${textColor}` };
  }
  return (
    <MetricNumbersWrapper>
      <MetricTotal style={textStyle}>{metricValue.humanizedNumber}</MetricTotal>
      <MetricUnit>{metricValue.humanizedUnit}</MetricUnit>
      {/* <MetricDiff>5%</MetricDiff> */}
    </MetricNumbersWrapper>
  );
};

export default MetricNumbers;
